var Comment = require('./comment')

module.exports = Backbone.Collection.extend({
	model: Comment,
	comparator: 'commentDate'
})
